import type { ICategory } from '~/components/widget/frequently-searched/types'

export const categories: ICategory[] = [
  {
    title: 'common.credits',
    url: '/credits',
    items: [
      {
        label: 'common.no_income_proof',
        url: '/credits/no-profit'
      },
      {
        label: 'common.no_collateral_guarantors',
        url: '/credits/no-guarantee'
      },
      {
        label: 'common.consumer',
        url: '/credits/consumer'
      },
      { label: 'common.mortgage', url: '/credits/mortgage' }
    ]
  },
  {
    title: 'common.deposits',
    url: '/deposits',
    items: [
      {
        label: 'widget.home_page.frequently_searched.categories.deposits.items.currency',
        url: '/deposits/currency'
      },
      {
        label: 'widget.home_page.frequently_searched.categories.deposits.items.replenished',
        url: '/deposits/replenished'
      },
      {
        label: 'widget.home_page.frequently_searched.categories.deposits.items.monthly_income',
        url: '/deposits/monthly_income'
      },
      {
        label: 'widget.home_page.frequently_searched.categories.deposits.items.capitalization',
        url: '/deposits/capitalization'
      }
    ]
  },
  {
    title: 'common.payment_cards',
    url: '/cards',
    items: [
      { label: 'common.credit_cards', url: '/cards/credit' },
      {
        label: 'widget.home_page.frequently_searched.categories.cards.items.free',
        url: '/cards/free'
      },
      {
        label: 'common.with_accrual',
        url: '/cards/interest'
      },
      {
        label: 'common.bonuses_discounts',
        url: '/cards/bonuses'
      }
    ]
  },
  {
    title: 'common.money_transfers',
    url: '/money-transfers',
    items: [
      {
        label: 'widget.home_page.frequently_searched.categories.money_transfers.items.kgs',
        url: '/money-transfers/kgs'
      },
      {
        label: 'widget.home_page.frequently_searched.categories.money_transfers.items.rub',
        url: '/money-transfers/rub'
      },
      {
        label: 'widget.home_page.frequently_searched.categories.money_transfers.items.usd',
        url: '/money-transfers/usd'
      },
      {
        label: 'widget.home_page.frequently_searched.categories.money_transfers.items.eur',
        url: '/money-transfers/eur'
      }
    ]
  }
]
